import React from "react";
import PropTypes from "prop-types";
// Material imports
import Checkbox from "@mui/material/Checkbox";
import Typography from "@mui/material/Typography";
import FormControl from "@mui/material/FormControl";
import FormGroup from "@mui/material/FormGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import makeStyles from "@mui/styles/makeStyles";
const useStyles = makeStyles(theme => ({
  root: {
    padding: "16px 24px 16px 24px",
    fontFamily: "Roboto"
  },
  title: {
    marginLeft: "-7px",
    marginRight: "24px",
    fontSize: "14px",
    color: theme.palette.text.secondary,
    textAlign: "left",
    fontWeight: 500
  },
  formGroup: {
    marginTop: "8px"
  },
  formControl: {},
  checkbox: {
    padding: "0px",
    width: "32px",
    height: "32px"
  },
  checkboxRoot: {},
  checked: {},
  label: {
    fontSize: "15px",
    marginLeft: "8px",
    color: theme.palette.text.primary
  }
}), {
  name: "MUIDataTableViewCol"
});
const ViewTableColumns = ({
  columns,
  options,
  components = {},
  onColumnUpdate,
  updateColumns
}) => {
  const classes = useStyles();
  const textLabels = options.textLabels.viewColumns;
  const CheckboxComponent = components.Checkbox || Checkbox;
  const anySelected = columns.some(c => c.display !== "true");
  const handleColChange = index => {
    onColumnUpdate(index);
  };
  const handleSelectAll = () => {
    const newColumns = [...columns];
    newColumns.map(col => col.display = anySelected ? "true" : "excluded");
    updateColumns(newColumns);
  };
  const selectAllTitle = anySelected ? "Select All" : "Unselect All";
  const renderCheckBox = (value, checked, onChange) => {
    return /*#__PURE__*/React.createElement(CheckboxComponent, {
      color: "primary",
      "data-description": "table-view-col",
      className: classes.checkbox,
      classes: {
        root: classes.checkboxRoot,
        checked: classes.checked
      },
      onChange: onChange,
      checked: checked,
      value: value
    });
  };
  return /*#__PURE__*/React.createElement(FormControl, {
    component: "fieldset",
    className: classes.root,
    "aria-label": textLabels.titleAria
  }, /*#__PURE__*/React.createElement(Typography, {
    variant: "caption",
    className: classes.title
  }, textLabels.title), /*#__PURE__*/React.createElement(FormGroup, {
    className: classes.formGroup
  }, /*#__PURE__*/React.createElement(FormControlLabel, {
    key: 0,
    classes: {
      root: classes.formControl,
      label: classes.label
    },
    control: renderCheckBox(selectAllTitle, anySelected ? false : true, handleSelectAll),
    label: selectAllTitle
  }), columns.map((column, index) => {
    return column.display !== "excluded" && column.viewColumns !== false && /*#__PURE__*/React.createElement(FormControlLabel, {
      key: index + 1,
      classes: {
        root: classes.formControl,
        label: classes.label
      },
      control: renderCheckBox(column.name, column.display === "true", () => handleColChange(index)),
      label: column.label
    });
  })));
};
ViewTableColumns.propTypes = {
  /** Columns used to describe table */
  columns: PropTypes.array.isRequired,
  /** Options used to describe table */
  options: PropTypes.object.isRequired,
  /** Callback to trigger View column update */
  onColumnUpdate: PropTypes.func,
  classes: PropTypes.object,
  components: PropTypes.object,
  updateColumns: PropTypes.func
};
export default ViewTableColumns;